module.exports = __webpack_public_path__ + "media/images/icons/cross-3b2678c02d90aaa0d2ae380a119c234b.svg";